import { render, staticRenderFns } from "./accredited-course-report.vue?vue&type=template&id=aa7a247a"
import script from "./accredited-course-report.vue?vue&type=script&lang=js"
export * from "./accredited-course-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports